import { POST_CREATE_NEWTAB_FAILURE, POST_CREATE_NEWTAB_REQUEST, POST_CREATE_NEWTAB_SUCCESS } from './types'
import axiosInstance from '../../utils/api'

export const postCreateNewTabRequest = () => {
  return {
    type: POST_CREATE_NEWTAB_REQUEST,
  }
}
export const postCreateNewTabSuccess = (value) => {
  return {
    type: POST_CREATE_NEWTAB_SUCCESS,
    payload: value,
  }
}
export const postCreateNewTabFailure = (error) => {
  return {
    type: POST_CREATE_NEWTAB_FAILURE,
    payload: error,
  }
}

export const postCreateNewTab =
  (payload, config = {}) =>
  async (dispatch) => {
    dispatch(postCreateNewTabRequest()) // FIXED

    return new Promise(async (resolve, reject) => {
      try {
        const response = await axiosInstance.post(`/api/admin/lbtab`, payload, config)
        const result = response.data
        dispatch(postCreateNewTabSuccess(result))
        resolve(result) // Or resolve(response) if you prefer
      } catch (error) {
        const errorMsg = error?.response?.data?.message || 'Unknown error'
        // dispatch(postCreateNewTabFailure(errorMsg))
        reject(errorMsg)
      }
    })
  }
